import {
  boolean,
  integer,
  jsonb,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uuid,
} from "drizzle-orm/pg-core";
import { orders } from "./order";

export const itemSourceEnum = pgEnum("item_source", ["OWNED", "MARKETPLACE", "CATALOG"]);

export const orderLineStatusEnum = pgEnum("order_line_status", ["PENDING", "PACKED", "CANCELLED"]);

export const orderLines = pgTable("order_lines", {
  id: uuid("id").primaryKey().defaultRandom(),
  orderId: uuid("order_id")
    .notNull()
    .references(() => orders.id),
  itemSource: itemSourceEnum("item_source").notNull(),
  itemId: text("item_id").notNull(),
  /** The platform's own inventory id. No FK: external platforms send their own ids. */
  inventoryItemId: text("inventory_item_id"),
  snapshot: jsonb("snapshot").notNull(),
  unitValue: integer("unit_value").notNull(),
  fulfillmentFee: integer("fulfillment_fee"),
  isSlowShip: boolean("is_slow_ship").notNull().default(false),
  status: orderLineStatusEnum("status").notNull().default("PENDING"),
  /**
   * Whether this line took stock when it was written (`reserveStock`). `false` marks a
   * record-only line (a tenant mirroring its own order record): its pack / ship / cancel must
   * not touch stock either. `null` predates the column and is treated as reserved.
   */
  stockReserved: boolean("stock_reserved"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});
